<template>
  <div id="faldon" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <div class="container-info">
      <div class="checkbox">
        <div class="ibbCheckbox-wrapper" style="position: relative;">
          <input type="checkbox" id="checkboxSelect" name="checkboxSelect" v-model="selectAll">
          <img v-if="selectAll" src="/img/icons/other-stuff/ibbCheck.svg">
        </div>
        <label for="checkboxSelect">{{ $t('buttons.selectAll') }}</label>
      </div>
      <p>{{ selectedCount }} {{ $t('files.selectedNodes') }}</p>
    </div>
    <div class="buttons-wrapper">
      <copy-button v-if="showCopyButton"></copy-button>
      <move-button v-if="showMoveButton"></move-button>
      <download-button></download-button>
      <button v-if="showArchiveButton" @click="archiveSharedDrive" :aria-label="$t('buttons.store')" :title="$t('buttons.store')" class="action" id="delete-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-archive"><polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line></svg>
        <span>{{ $t('buttons.store') }}</span>
      </button>
      <button v-else-if="isSharedWithMe && isShared" @click="exitSharedDrive" :aria-label="$t('buttons.exit')" :title="$t('buttons.exit')" class="action" id="delete-button">
        <log-out-icon size="1.5x" class="custom-class"></log-out-icon>
        <span>{{ $t('buttons.exit') }}</span>
      </button>
      <delete-button v-else-if="canDeleteElement"></delete-button>
      <share-button v-if="canShareElement"></share-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import CopyButton from '@/components/buttons/Copy.vue';
import MoveButton from '@/components/buttons/Move.vue';
import DownloadButton from '@/components/buttons/Download.vue';
import DeleteButton from '@/components/buttons/Delete.vue';
import ShareButton from '@/components/buttons/Share.vue';
import { ROUTES } from '@/router';
import { LogOutIcon } from 'vue-feather-icons';

export default {
  name: 'faldon',
  data: function () {
    return {
      selectAll: false,
      isShared: false
    };
  },
  components: {
    CopyButton,
    MoveButton,
    DownloadButton,
    DeleteButton,
    LogOutIcon,
    ShareButton
  },
  computed: {
    ...mapGetters([
      'selectedCount',
      'isSharedDrive',
      'isBackup',
    ]),
    ...mapState(['req', 'permissions', 'permissionsSharedDrive', 'isMaxStorage', 'selected']),
    isMyDrives() {
      return this.$route.name === ROUTES.MY_SHARED_DRIVES;
    },
    isSharedWithMe() {
      return this.$route.name === ROUTES.SHARED_WITH_ME;
    },
    canShareElement() {
      if (this.permissions === 0 && this.permissionsSharedDrive === 0 && this.selectedCount === 1 && (!this.isBackup || (this.isBackup && (this.req.items[this.selected[0]].nodeType === Module.NodeType.FILE.value) || (this.req.items[this.selected[0]].nodeType === Module.NodeType.FOLDER.value)))) {
        return true;
      } else {
        return false;
      }
    },
    canDeleteElement() {
      if (this.permissions === 0 && this.permissionsSharedDrive === 0 && (!this.isBackup || (this.isBackup && this.req.items[this.selected[0]].nodeType !== Module.NodeType.FILE.value && this.req.items[this.selected[0]].nodeType !== Module.NodeType.FOLDER.value))) {
        return true;
      } else {
        return false;
      }
    },
    showMoveButton() {
      if (this.selected.length > 1) {
        for (let item of this.selected) {
          if (this.req.items[item].type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
            return false;
          }
        }
      }
      if (this.permissions === 0 && this.permissionsSharedDrive === 0 && !this.isShared && !this.isBackup) {
        return true;
      } else {
        return false;
      }
    },
    showCopyButton() {
      if (this.selected.length > 1) {
        for (let item of this.selected) {
          if (this.req.items[item].type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
            return false;
          }
        }
      }
      if (this.permissions === 0 && this.permissionsSharedDrive === 0 && !this.isMaxStorage && !this.isShared && !this.isBackup) {
        return true;
      } else {
        return false;
      }
    },
    showArchiveButton() {
      if (this.selected.length > 1) {
        for (let item of this.selected) {
          if (this.req.items[item].type !== Module.NodeType.SHARED_DRIVE_ROOT.value) {
            return false;
          }
        }
      }
      if (this.isMyDrives && this.isShared) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    selectAll (val) {
      if (val) {
        this.resetSelected();
        if (this.req.items) {
          for (let item of this.req.items) {
            this.addSelected(item.index);
          }
        } else {
          for (let i = 0; i < this.req.length; i++) {
            this.addSelected(i);
          }
        }
      } else {
        this.resetSelected();
      }
    },
    selected() {
      this.fecthData();
    }
  },
  mounted() {
    this.fecthData();
  },
  beforeDestroy () {
    this.setIsFaldon(false);
  },
  methods: {
    ...mapMutations(['setIsFaldon', 'addSelected', 'resetSelected']),
    fecthData() {
      if (this.isSharedDrive && this.$route.hash === '') {
        this.isShared = true;
      } else if (this.req.items[this.selected[0]].type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
        this.isShared = true;
      }
    },
    mouseEnter() {
      this.setIsFaldon(true);
    },
    mouseLeave() {
      this.setIsFaldon(false);
    },
    archiveSharedDrive () {
      this.$store.commit('showHover', 'archive-shared-drive');
    },
    exitSharedDrive() {
      this.$store.commit('showHover', 'delete');
    },
  }
};
</script>
